import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";
import { handleError, authHeader } from "../helper";

export const LeaderDashboardService = {
  getStrengthAndAgilityFlag,
  getLeaderBoardNotes,
  getStrengthAndAgilityDataByStationId,
  getAnthrosLeaderBoardByStationId,
  getShootingDrillsByStationId,
  getShootingDrillLeaderBoardByLoggedInFavPlayers,
  getLeaderboardAnthroSAAgilityByLoggedInFavPlayers,
  getLeaderboardAnthroSAAgilityByEventID,
  getShootingDrillLeaderBoardByEventID,
  getLeaderboardAnthrosDataByEventID,
  getLeaderboardStrengthAndAgilityByEventID,
  getShuttleRunTrialLaserTimeByEventID,
  getProLaneTrialLaserTimeByEventID,
  getThreeFourTrialLaserTimeByEventID,
  getAnthrosConsolidatedLeaders,
  getSASConsolidatedLeaders,
  getShootingConsolidatedLeaders,
};

async function getStrengthAndAgilityFlag() {
  return await APIHelper.get(
    APIURLConstants.GET_STRENGTH_AND_AGILITY_FLAG,
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getLeaderBoardNotes() {
  return await APIHelper.get(
    APIURLConstants.GET_LEADER_BOARD_NOTES,
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getStrengthAndAgilityDataByStationId(
  eventId,
  stationId,
  state,
  userBy
) {
  return await APIHelper.get(
    APIURLConstants.GET_STRENGTH_AND_AGILITY_DATA(
      eventId,
      stationId,
      state,
      userBy
    ),
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getAnthrosLeaderBoardByStationId(eventId, stationId, userBy) {
  return await APIHelper.get(
    APIURLConstants.GET_ANTHROS_LEADER_BOARD_DATA(eventId, stationId, userBy),
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getShootingDrillsByStationId(eventId, stationId, userBy) {
  return await APIHelper.get(
    APIURLConstants.GET_SHOOTING_DRILLS_DATA(eventId, stationId, userBy),
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getLeaderboardAnthroSAAgilityByLoggedInFavPlayers(
  eventId,
  userName
) {
  const response = await APIHelper.get(
    APIURLConstants.GET_FAV_PLAYERS_STRENGTH_AND_AGILITY_DATA_BY_USER_NAME_AND_EVENTID(
      eventId,
      userName
    ),
    authHeader()
  );
  return response;
}

async function getLeaderboardAnthroSAAgilityByEventID(eventId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_STRENGTH_AND_AGILITY_DATA_BY_EVENTID(
      eventId,
      userBy
    ),
    authHeader()
  );
  return response;
}

async function getShootingDrillLeaderBoardByLoggedInFavPlayers(
  eventId,
  userName
) {
  const response = await APIHelper.get(
    APIURLConstants.GET_FAV_PLAYERS_SHOOTING_DRILLS_DATA_BY_USER_NAME_AND_EVENTID(
      eventId,
      userName
    ),
    authHeader()
  );
  return response;
}

async function getShootingDrillLeaderBoardByEventID(eventId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_FAV_PLAYERS_SHOOTING_DRILLS_DATA_BY_EVENTID(
      eventId,
      userBy
    ),
    authHeader()
  );
  return response;
}

async function getLeaderboardAnthrosDataByEventID(eventId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_ANTHROS_DATA_BY_EVENTID(eventId, userBy),
    authHeader()
  );
  return response;
}

async function getLeaderboardStrengthAndAgilityByEventID(eventId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_STRENGTH_AND_AGILITY_DATA_BY_EVENTID(
      eventId,
      userBy
    ),
    authHeader()
  );
  return response;
}

async function getShuttleRunTrialLaserTimeByEventID(eventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_SHUTTLE_RUN_LASER_TIME(eventId),
    authHeader()
  );
  return response;
}

async function getProLaneTrialLaserTimeByEventID(eventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PRO_LANE_LASER_TIME(eventId),
    authHeader()
  );
  return response;
}

async function getThreeFourTrialLaserTimeByEventID(eventId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_THREE_FOUR_LASER_TIME(eventId),
    authHeader()
  );
  return response;
}

async function getAnthrosConsolidatedLeaders(eventId) {
  return await APIHelper.get(
    APIURLConstants.GET_ANTHROS_CONSOLIDATED_LEADERS(eventId),
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getSASConsolidatedLeaders(eventId) {
  return await APIHelper.get(
    APIURLConstants.GET_SAS_CONSOLIDATED_LEADERS(eventId),
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}

async function getShootingConsolidatedLeaders(eventId) {
  return await APIHelper.get(
    APIURLConstants.GET_SHOOTING_CONSOLIDATED_LEADERS(eventId),
    authHeader()
  )
    .then((result) => {
      return result;
    })
    .catch(handleError);
}
